export const AppRoutes = {
  auth: {
    login: '/login',
    register: '/register',
    join: '/join',
    forgotPassword: '/auth/forgot-password',
    resetPassword: '/auth/reset-password',
    pendingEmail: '/auth/pending-email',
  },
  public: {
    landing: '/',
    pricing: '/pricing',
    demo: '/demo',
    dataVolleyAlternative: '/alternative-datavolley',
    dataVolleyComparison: '/datavolley-vs-volleystats-pro',
  },
  dashboard: {
    home: '/dashboard',
    verifyEmail: '/dashboard/verify',
  },
  match: {
    setup: '/match-setup',
    import: '/matches/import',
    importUpload: '/matches/import/upload',
    importDraft: (draftId: string | number = ':draftId') => `/matches/import/${draftId}`,
    input: '/match',
    admin: '/allmatchs',
    adminOthers: '/allmatchs?view=others',
  },
  team: {
    list: '/teams',
    detail: (teamId: string | number = ':teamId') => `/team/${teamId}`,
    opponentDetail: (teamId: string | number = ':teamId', opponentTeamId: string | number = ':opponentTeamId') =>
      `/team/${teamId}/opponents/${opponentTeamId}`,
  },
  scout: {
    home: '/scout',
  },
  gamePlans: {
    list: '/game-plans',
    view: (teamId: string | number = ':teamId', opponentTeamId: string | number = ':opponentTeamId') =>
      `/game-plans/${teamId}/${opponentTeamId}`,
  },
  profile: {
    main: '/profile',
  },
  payment: {
    success: '/payment/success',
  },
  stats: {
    main: '/stats',
    withMatch: (matchId: string | number = ':matchId') => `/stats/${matchId}`,
  },
  membership: {
    requests: '/membership-requests',
  },
  cartography: {
    main: '/trajectories',
  },
  matchReview: {
    main: '/match-review',
    withMatch: (matchId: string) => `/match-review?match=${encodeURIComponent(matchId)}`,
  },
  video: {
    main: '/video',
  },
  superAdmin: {
    dashboard: '/super-admin',
  },
  faq: {
    main: '/faq',
  },
  nativeApp: {
    more: '/more',
  },
  tutorials: {
    main: '/tutorials',
    article: (tutorialId: string = ':tutorialId') => `/tutorials/${tutorialId}`,
  },
  legal: {
    mentions: '/mentions-legales',
    privacy: '/confidentialite',
    cgu: '/cgu',
    cgv: '/cgv',
  },
} as const;

export type AppRoute = typeof AppRoutes;

